export enum PresentationRoutePathsEnum {
  PRESENTATION = 'presentation',
}
